<template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="bullhorn" />
                    <h3>Zarządzanie ogłoszeniami</h3></div>
                <small>Poniżej możesz wysłać prywatną wiadomość lub zaczepić osoby z Twojej grupy z wybraną wiadomością.</small>
            </div>
        </header>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <form name="form" @submit.prevent="saveAnnoucement">
                        <div class="card-header">
                            <h5> Utwórz ogłoszenie </h5>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label for="message">Wiadomość</label>
                                <textarea
                                        v-model="message"
                                        v-validate="getRules()"
                                        class="form-control"
                                        name="message"
                                ></textarea>
                                <div
                                        v-if="errors.has('message')"
                                        class="alert alert-danger"
                                        role="alert"
                                >{{ errors.first('message') }}</div>
                            </div>

                            <div class="form-group">
                                <label for="isPoke">Rodzaj powiadomienia (Poke | Priv)</label><br>
                                <toggle-button v-model="isPoke" :labels="{checked: 'Poke', unchecked: 'Priv'}" :color="{checked: '#ffc107', unchecked: '#007bff'}" :width="100" :height="40" name="isPoke" ref="isPoke" :sync="true"/>
                            </div>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-success" :disabled="loading">
                                <span><font-awesome-icon icon="check"/> Wyślij</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AnnouncementsService from '../services/announcements.service';
    import Vue from "vue";
    import SelectOnline from "../components/SelectOnline";

    export default {
        name: 'Announcements',
        data() {
            return {
                loading: true,
                clients: [],
                clientsData: [],
                message: "",
                isPoke: false
            };
        },
        mounted() {
            this.loading = false;
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            premiumChannel() {
                return this.$store.state.auth.premiumChannel;
            },
        },
        methods: {
            getRules() {
                return this.isPoke ? 'required|min:3|max:100' : 'required|min:3|max:600';
            },
            async saveAnnoucement() {
                this.loading = true;
                this.$validator.validateAll().then(async isValid => {
                    if (!isValid) {
                        this.loading = false;
                        return;
                    }

                    AnnouncementsService.getOnlineClients().then(
                        async (response) => {
                            let clients = response.data.onlineClients;
                            let ComponentClass = Vue.extend(SelectOnline);
                            let vueFormInstance = new ComponentClass({
                                propsData: {clients: clients, onlyOne: false, allChecked: true, idType: "clid"}
                            });

                            const { value } = await Vue.swal.fire({
                                title: 'Wybierz użytkowników',
                                html: '<div id="clients"></div>',
                                showCancelButton: true,
                                confirmButtonText: 'Ok',
                                cancelButtonText: 'Anuluj',
                                showLoaderOnConfirm: true,
                                onBeforeOpen: () => {
                                    vueFormInstance.$mount();
                                    document.getElementById("clients").appendChild(vueFormInstance.$el);
                                },
                                preConfirm: () => {
                                    let result =  vueFormInstance.getResults();
                                    vueFormInstance.$destroy();
                                    vueFormInstance = null;
                                    return result;
                                }
                            });

                            if (value) {
                                AnnouncementsService.makeAnnouncement(value, this.isPoke, this.message).then(
                                    (response) => {
                                        Vue.swal.fire({
                                            title: 'Użytkownicy zostali powiadomieni!',
                                            text: response.data.info,
                                            icon: 'success',
                                            timer: 1000,
                                            showConfirmButton: false,
                                        });
                                        this.message = "";
                                        this.$validator.reset();
                                        this.isPoke = false;
                                        this.loading = false;
                                    },
                                    error => {
                                        this.loading = false;
                                        console.log(error)
                                    }
                                );
                            } else
                                this.loading = false;
                        },
                        error => {
                            this.loading = false;
                            console.log(error)
                        }
                    );
                });
            }
        }
    };
</script>
